module.exports = __webpack_public_path__ + "99413d28a28888aa9176b98adf172d4b.pdf";